export default {"src":"/_next/static/media/rocketThree.f26ff2f6.svg","height":25,"width":25};